import { render, staticRenderFns } from "./OrderTypeSelection.vue?vue&type=template&id=c53ae182&"
import script from "./OrderTypeSelection.vue?vue&type=script&lang=js&"
export * from "./OrderTypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports